import type { ReactElement } from 'react';
import { useSearchParams } from 'react-router';
import { ButtonLink } from '../ui';
import { noAccessCopy } from './messages';
import { OutsideCard, OutsidePage } from './OutsidePage';

/**
 * Signed in with Microsoft Entra ID, but no MyRewards access (`?reason=not_in_directory` or
 * `inactive`). There is no session on this page, so nothing here calls the API.
 */
export function NoAccessPage(): ReactElement {
  const [params] = useSearchParams();
  const copy = noAccessCopy(params.get('reason'));
  return (
    <OutsidePage title="No access">
      <OutsideCard
        icon="lock"
        title={copy.title}
        actions={
          <ButtonLink href="/sign-in" variant="navy">
            Back to sign-in
          </ButtonLink>
        }
      >
        <p>{copy.body}</p>
        <p>{copy.next}</p>
      </OutsideCard>
    </OutsidePage>
  );
}
